import React, { ChangeEvent, useMemo } from "react";
import { useState } from "react";
import { useTranslation } from 'react-i18next';

import Styles from "../../../scss/orderHistory.module.scss";
import { ReactComponent as ArrowDownIcon } from "../../../assets/images/icon-arrow-down.svg";
import { ReactComponent as SearchIcon } from "../../../assets/images/icon-search.svg";
import { SearchItems } from "../constants";

export interface IOrderListSearchState {
    key: string;
    value: string;
}

interface IOrderListSearchProps {
    selectedSearchState: IOrderListSearchState;
    onSearchChange: (value: ChangeEvent<HTMLInputElement>) => void;
    setSearchState: (value: IOrderListSearchState) => void;
}

export function OrderListSearch({
    selectedSearchState,
    setSearchState,
    onSearchChange
}: IOrderListSearchProps) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const title = useMemo(() => {
        const index = SearchItems.findIndex((sItems) => sItems.key === selectedSearchState.key);

        return SearchItems[index].value;
    }, [selectedSearchState]);
    function onItemClick(key: string, value: string) {
        if (selectedSearchState.value !== value) {
            setSearchState({ key: key, value: value });
        }
        setIsOpen(false);
    }
    return <div tabIndex={-1} onBlur={() => setIsOpen(false)}>
        <div className={Styles.selectBar} onClick={() => setIsOpen((isOpenState) => !isOpenState)}>
            <p>{t(title)}</p>
            <ArrowDownIcon />
            <span></span>
        </div>
        <input type={selectedSearchState.key === "order_table_number" ? "number" : "text"}
            placeholder={t('orderHistory.search.placeholder') + t(title)} onChange={onSearchChange}
            data-component-name="searchInput" />
        <SearchIcon />
        <div className={`${Styles.options} ${isOpen ? Styles.openSelectContainer : undefined}`} onBlur={() => setIsOpen(false)} >
            {
                SearchItems.map((item: { key: string, value: string; }) =>
                    <p key={item.key} onClick={() => onItemClick(item.key, t(item.value))}
                    >{t(item.value)}</p>
                )
            }
        </div>
    </div>;
}